export function initHeroSliders(Glide) {
  // Add custom CSS for fade transition
  const fadeStyle = document.createElement('style');
  fadeStyle.textContent = `
    .glide__slide {
      transition: opacity 1200ms ease-in-out, transform 1200ms ease-in-out, box-shadow 1200ms ease-in-out;
    }
    .glide__slide--active {
      z-index: 2;
    }
    /* Only hide slides that are before the active slide */
    // .glide__slide--prev {
    //   opacity: 0;
    // }
  `;
  document.head.appendChild(fadeStyle);
  const heroSliders = document.querySelectorAll('.js-hero-slider');

  if (heroSliders.length) {
    heroSliders.forEach((slider) => {
      // Initialize Glide instance
      const HeroSlider = new Glide(slider, {
        startAt: 0,
        type: 'carousel', // Enable seamless looping
        perView: 1,
        gap: 24,
        peek: { before: 0, after: 256 },
        animationDuration: 1200,
        animationTimingFunc: 'ease-in-out',
        autoplay: 8000,
        hoverpause: true,
        keyboard: true,
        breakpoints: {
          1200: {
            peek: { before: 0, after: 250 },
          },
          992: {
            peek: { before: 0, after: 150 },
          },
          768: {
            peek: { before: 0, after: 0 },
          },
        },
      });

      // Get slide elements
      const slides = slider.querySelectorAll('.glide__slide');
      const firstSlide = slides[0];

      // Get control buttons
      const prevButton = slider.querySelector('[data-glide-dir="<"]');
      const nextButton = slider.querySelector('[data-glide-dir=">"]');

      // Slide change handler - with continuous looping, we don't need to disable buttons
      const handleSlideChange = () => {
        // With rewind: true, we don't need to disable buttons at the ends
        // All buttons should remain enabled for continuous looping
        prevButton?.removeAttribute('disabled');
        nextButton?.removeAttribute('disabled');
      };

      // Set up event handlers
      HeroSlider.on('run.after', handleSlideChange);

      // With continuous looping, we don't need to disable the prev button at start

      // Track if this is the first transition
      let isFirstTransition = true;
      
      // Box-shadow animations and initial setup
      HeroSlider.on('mount.after', function () {
        // Apply shadow to initial active slide immediately without transition
        const initialActiveSlide = slider.querySelector(
          '.glide__slide--active'
        );
        if (initialActiveSlide) {
          // Remove transition for initial setup to apply shadow instantly
          initialActiveSlide.style.transition = 'none';
          initialActiveSlide.style.boxShadow =
            '0px 0px 61.4px 24px rgba(4, 14, 24, 0.2)';

          // Force a reflow to ensure the transition gets disabled
          void initialActiveSlide.offsetWidth;
        }
        
        // Directly control slide visibility on initial load
        const allSlides = slider.querySelectorAll('.glide__slide');
        const totalSlides = allSlides.length;
        
        // First make all slides invisible
        allSlides.forEach(slide => {
          slide.style.opacity = '0';
        });
        
        // Calculate the number of original slides (without clones)
        // In carousel mode, Glide typically clones slides, so we need to determine the original count
        // We can estimate this by dividing the total by 3 (original + 2 sets of clones)
        const originalSlideCount = Math.round(totalSlides / 3);
        
        // Calculate the start of the middle section (the second set of slides)
        const middleSectionStart = originalSlideCount;
        const middleSectionEnd = middleSectionStart + originalSlideCount;
        
        console.log(`Total slides: ${totalSlides}, Original count: ${originalSlideCount}, Middle section: ${middleSectionStart}-${middleSectionEnd}`);
        
        // Make the middle section of slides visible
        for (let i = middleSectionStart; i < Math.min(middleSectionEnd, totalSlides); i++) {
          allSlides[i].style.opacity = '1';
        }
        
        // Also make the active slide visible
        const activeSlide = slider.querySelector('.glide__slide--active');
        if (activeSlide) {
          activeSlide.style.opacity = '1';
        }
      });

      // Before the transition starts
      HeroSlider.on('run.before', function (move) {
        // Reset box shadows on all slides
        const allSlides = slider.querySelectorAll('.glide__slide');
        allSlides.forEach((slide) => {
          slide.style.boxShadow = '0px 0px 0px 0px rgba(4, 14, 24, 0)';
          slide.style.removeProperty('opacity');
        });
        
        // Determine which slide will become active
        let nextSlide;
        
        if (move.direction === '>') {
          // Going forward - get the next slide
          nextSlide = slider.querySelector('.glide__slide--active + .glide__slide');
        } else {
          // Going backward - get the previous slide
          const slides = slider.querySelectorAll('.glide__slide');
          const activeIndex = Array.from(slides).findIndex(slide => 
            slide.classList.contains('glide__slide--active'));
          
          // Handle looping at the beginning
          const prevIndex = activeIndex === 0 ? slides.length - 1 : activeIndex - 1;
          nextSlide = slides[prevIndex];
        }
        
        // Apply shadow to the next active slide
        if (nextSlide) {
          nextSlide.style.boxShadow = '0px 0px 61.4px 24px rgba(4, 14, 24, 0.2)';
        }
      });

      // After the transition completes
      HeroSlider.on('run.after', function () {
        // Apply shadow to current active slide
        const activeSlide = slider.querySelector('.glide__slide--active');
        if (activeSlide) {
          activeSlide.style.boxShadow = '0px 0px 61.4px 24px rgba(4, 14, 24, 0.2)';
        }
        
        // If this is the first transition, make all slides visible
        if (isFirstTransition) {
          // Make all slides visible
          const allSlides = slider.querySelectorAll('.glide__slide');
          allSlides.forEach(slide => {
            slide.style.opacity = '1';
          });
          isFirstTransition = false;
        }
        
        // Mark all slides before the active slide with the prev class
        const allSlides = slider.querySelectorAll('.glide__slide');
        const activeIndex = Array.from(allSlides).findIndex(slide => 
          slide.classList.contains('glide__slide--active'));
        
        // First remove all prev classes
        allSlides.forEach(slide => slide.classList.remove('glide__slide--prev'));
        
        // Then add prev class to slides before the active one
        allSlides.forEach((slide, index) => {
          // In carousel mode, we need to handle the circular nature
          // For slides at the beginning, they come after slides at the end in the carousel
          if (index < activeIndex) {
            // slide.classList.add('glide__slide--prev');
            slide.style.opacity = '0';
          }
        });
      });
      
      // Mount the slider
      HeroSlider.mount();
    });
  }
}
